export default function render(parameter, parameterValue) {
  const {role_name: roleName, value} = parameterValue;
  return `${value} (${roleName})`;
}
